import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// public/index.html ships static title/description/canonical/OG tags as a
// fallback for crawlers that don't run JS (social link previews, some bots).
// react-helmet-async only ever adds its own tags on mount, it doesn't remove
// these — so without this cleanup every route would carry two <meta
// name="description">/<link rel="canonical"> tags (the static one first).
// Stripping them once, before mount, hands full control to Helmet for anyone
// whose client actually runs this script.
document
  .querySelectorAll(
    'title, meta[name="description"], link[rel="canonical"], meta[property^="og:"], meta[name^="twitter:"]'
  )
  .forEach((node) => node.remove());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
